import { render } from "./ChatDetailDialog.vue?vue&type=template&id=47b2df5e&ts=true"
import script from "./ChatDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ChatDetailDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__